import React from 'react';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import EventPublicPage from 'pages/event/public/Detail.page';
import ReferralPublicPage from 'pages/event/public/Referral.page';

class EventRedirectComponent extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props);
        this.fetch = this.fetch.bind(this)
        this.state = {
            eventId: '',
            loading: true,
            userId: '',
            code: '',
            userCode: ''
        }
    }

    public componentDidMount() {
        this.fetch();
    }

    public fetch() {
        const param = this.props.match.params.code.toString().split('-');
        fetchGraphQL(
            `
            query {
                url {
                    getByCode(code:"${param[0]}") {
                        eventId
                        teamMap {
                            userId
                            index
                        }
                    }
                }
            }
        `
        ).then((res) => {
            if (param.length === 2) {
                // Referral Ticket
                const user = res.url.getByCode.teamMap.find(item => {
                    return item.index === param[1]
                })
                this.setState({
                    eventId: res.url.getByCode.eventId,
                    loading: false,
                    userId: user.userId,
                    code: param[0],
                    userCode: param[1]
                })
            } else {
                // Public ticket
                this.setState({
                    eventId: res.url.getByCode.eventId,
                    loading: false,
                    code: param[0]
                })
            }
        })
    }
    public render() {

        if (this.state.loading === true || this.state.eventId === '') {
            return null
        } else if (this.state.userId !== '') {    // Referral
            return <ReferralPublicPage {...this.props} eventId={this.state.eventId} promoterId={this.state.userId} code={this.state.code} userCode={this.state.userCode} />
        } else {                                // General
            return <EventPublicPage {...this.props} eventId={this.state.eventId} code={this.state.code} />
        }
        // return <div />
    }
}

export default EventRedirectComponent;



// WEBPACK FOOTER //
// ./src/components/redirect/eventredirect.tsx